import React from 'react';
import { KYCFieldRow } from './KYCFieldRow';
import { KYCField } from './PersonalInfoTab';
interface VerificationsTabProps {
  fields: KYCField[];
  onFieldChange: (id: string, updates: Partial<KYCField>) => void;
  onSelectAll: (selected: boolean) => void;
}
// All verification fields have the same metadata - Boolean type only
const verificationMetadata = {
  fieldType: 'dropdown' as const,
  explanation: 'Boolean (Yes/No)'
};
export function VerificationsTab({
  fields,
  onFieldChange,
  onSelectAll
}: VerificationsTabProps) {
  const allSelected = fields.length > 0 && fields.every(f => f.selected);
  return <div className="space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-440">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-441">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-442">
          <div className="flex items-center" data-id="element-443">
            <input type="checkbox" checked={allSelected} onChange={e => onSelectAll(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer" data-id="element-444" />
            <span className="ml-4 text-sm font-semibold text-gray-700" data-id="element-445">
              Required Verifications
            </span>
          </div>
          <div className="flex space-x-12 pr-6" data-id="element-446">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider w-24 text-center" data-id="element-447">
              Configuration
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-448">
          {fields.map(field => <KYCFieldRow key={field.id} label={field.label} isSelected={field.selected} isMandatory={field.mandatory} isOptional={field.optional} fieldType={verificationMetadata.fieldType} explanation={verificationMetadata.explanation} onToggleSelect={checked => onFieldChange(field.id, {
          selected: checked
        })} onToggleMandatory={checked => onFieldChange(field.id, {
          mandatory: checked,
          optional: checked ? false : field.optional
        })} onToggleOptional={checked => onFieldChange(field.id, {
          optional: checked,
          mandatory: checked ? false : field.mandatory
        })} data-id="element-449" />)}
        </div>
      </div>
    </div>;
}